import { create } from 'zustand';

import { HeadingClientFilters } from '@/data/models/headingClient.interface';
import { Platform } from '@/data/models/platform.interface';

interface HeadingClientsSelectionState {
  prefilledPlatform: Platform | null;
  prefilledFilters: HeadingClientFilters | null;
  prefilledHeadingClientPlatform: string | null;
  currentPlatform: Platform | null;
  currentFilters: HeadingClientFilters | null;
  currentHeadingClientPlatform: string | null;
  setPrefilledSelection: (
    _platform: Platform | null,
    _filters: HeadingClientFilters | null,
  ) => void;
  setPrefilledHeadingClientPlatform: (_platform: string | null) => void;
  clearPrefilledSelection: () => void;
  setCurrentSelection: (
    _platform: Platform | null,
    _filters: HeadingClientFilters | null,
  ) => void;
  clearCurrentSelection: () => void;
}

const useHeadingClientsSelectionStore = create<HeadingClientsSelectionState>(
  (set) => ({
    prefilledPlatform: null,
    prefilledFilters: null,
    prefilledHeadingClientPlatform: null,
    currentPlatform: null,
    currentFilters: null,
    currentHeadingClientPlatform: null,

    setPrefilledSelection: (
      platform: Platform | null,
      filters: HeadingClientFilters | null,
    ) => {
      set({
        prefilledPlatform: platform,
        prefilledFilters: filters,
      });
    },

    setPrefilledHeadingClientPlatform: (platform: string | null) => {
      set({ prefilledHeadingClientPlatform: platform });
    },

    clearPrefilledSelection: () => {
      set({
        prefilledPlatform: null,
        prefilledFilters: null,
        prefilledHeadingClientPlatform: null,
      });
    },

    setCurrentSelection: (
      platform: Platform | null,
      filters: HeadingClientFilters | null,
    ) => {
      set({
        currentPlatform: platform,
        currentFilters: filters,
      });
    },

    clearCurrentSelection: () => {
      set({
        currentPlatform: null,
        currentFilters: null,
        currentHeadingClientPlatform: null,
      });
    },
  }),
);

export default useHeadingClientsSelectionStore;
